var themeIds = ["nib", "navigator", "foundation", "qantas", "gu", "suncorp", "aami", "apia", "tal", "iman", "ing", "priceline", "nibLegacy", "worldNomads", "nsi", "cota", "australianSeniors", "real", "aanz", "edi", "tid"];
export var formTypes = ["light", "white"]; // Colors:
// Focus:
// Mode:
// Typography:
// Link:
// Buttons:
// Forms:
// Small Footer:
// Panel: